// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2kDvw","title":"InfoRow_title__3xizx"};